import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PrivacyPolicy from "../page/public/PrivacyPolicy";
import TermsPolicy from "../page/public/TermsPolicy";
import RefundPolicy from "../page/public/RefundPolicy";
import About from "../page/public/About";
import ContactUs from "../page/public/ContactUs";
import Login from "../page/private/Login";
import AdminDashboard from "../AdminDashboard/AdminDashboard";
import UserManagement from "../UserManagement/UserManagement";
import EditProfile from "../UserManagement/EditProfile";
import VariantPlans from "../VariantPlans/VariantPlans";
import VariantPlansEdit from "../VariantPlans/VariantPlansEdit";
import FontsDashboard from "../FontsDashboard/FontsDashboard";
import VariantFaq from "../VariantFaq/VariantFaq";
import VariantFaqEdit from "../VariantFaq/VariantFaqEdit";
import UserFilesList from "../AdminDashboard/UserFilesList";
import UserDesignsList from "../AdminDashboard/UserDesignsList";
import Profile from "../page/private/Profile/Profile";
import BillingHistory from "../page/BillingHistory";
import PlansOld from "../components/Plans";
import Design from "../design/Design";
import Forgetpass from "../page/private/Forgetpass";
import Signup from "../page/private/Signup";
import Verifyotp from "../page/private/Verifyotp";
import VerifyForgetPasswordOtp from "../page/VerifyForgetPasswordOtp";
import Welcome from "../components/Welcome";
import Payment from "../components/Payment";
import Invoice from "../Invoice/Invoice";
import PayAsUsePayment from "../components/PayAsUsePayment";
import ExportAfterPayForPayAsUse from "../page/private/ExportAfterPayForPayAsUse";
import PolotnoDesign from "../page/private/PolotnoDesign/PolotnoDesign";
import Export from "../page/private/PolotnoDesign/Export";
import PolotnoNewDesign from "../page/private/PolotnoDesign/PolotnoNewDesign";
import Variation from "../page/private/Variation/Variation";
import SizesShirt from "../page/private/Variation/Sizes.jsx";
import EditTshirt from "../page/private/PolotnoDesign/EditTshirt";
import PolotnoDesignNew from "../page/private/PolotnoDesign/PolotnoDesignNew";
import Toast from "../components/Toast.jsx";
import DashboardNumberViewAll from "../AdminDashboard/DashboardNumberViewAll.jsx";
import NewPassword from "../page/private/NewPassword";
import ResetPassword from '../page/private/ResetPassword.jsx';
import MainLogin from "../page/private/MainLoginPage"
import MyDesigns from "../page/private/MyDesigns.jsx";
import ExportV2 from "../page/private/PolotnoDesign/ExportV2.jsx";
import ExportOptimised from "../page/private/PolotnoDesign/ExportV3.jsx";
import Plans from "../page/private/plans/Plans.jsx";
import ProtectedHome from "../page/private/ProtectedHome.jsx";
import Home from "../page/private/Home";

const LoginHome = lazy(() => import("../page/private/Home"));

export default function PublicRoutes({ store, exportStore }) {
  // Load fonts on app initialization

  return (
    <>
      <Toast />

      <Suspense>
        <Routes>
        <Route path="/" element={<ProtectedHome store={store} />} />
          {/* <Route exact path="/" element={<Home />} /> */}
          <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route exact path="/termspolicy" element={<TermsPolicy />} />
          <Route exact path="/refundpolicy" element={<RefundPolicy />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact-us" element={<ContactUs />} />

          <Route path="/Login" element={<Login />} />
          <Route path="/Forgetpass" element={<Forgetpass />} />
          <Route path="/Signup" element={<Signup />} />
          <Route path="/verify-email" element={<Verifyotp />} />
          <Route
            path="/verify-forgetpassword-otp"
            element={<VerifyForgetPasswordOtp />}
          />
          <Route path='/new-password' element={<NewPassword />} />
          <Route path='/reset-password' element={<ResetPassword />} />
          <Route path="/main-login" element={<MainLogin />} />
          <Route path="/welcome" element={<Welcome />} />

          <Route path="/payment" element={<Payment />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/payforpayasuse" element={<PayAsUsePayment />} />
          <Route
            exact
            path="/payasuse/paid/export-new"
            element={<ExportAfterPayForPayAsUse />}
          />

          {/* <Route path="/" element={<LoginHome store={store} />} /> */}
          <Route path="/admindashboard" element={<AdminDashboard />} />
          <Route path="/usermanagement" element={<UserManagement />} />
          <Route path="/userlist" element={<DashboardNumberViewAll />} />
          <Route path="/editprofile/:id?" element={<EditProfile />} />
          <Route path="/viewprofile/:id?" element={<EditProfile />} />
          <Route path="/varintplans" element={<VariantPlans />} />
          <Route path="/varintplansedit" element={<VariantPlansEdit />} />
          <Route path="/fontsdashboard" element={<FontsDashboard />} />
          <Route path="/varintfaq" element={<VariantFaq />} />
          <Route path="/variantfaqedit" element={<VariantFaqEdit />} />
          <Route path="/admin/user-files" element={<UserFilesList />} />
          <Route path="/admin/user-designs" element={<UserDesignsList />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/billing-history" element={<BillingHistory />} />
          <Route path="/plansold" element={<PlansOld />} />
          <Route path="/plans" element={<Plans />} />
          {/* <Route path="/Design" element={<Design />} /> */}
          {/* <Route path="/Design" element={<PolotnoDesign store={store} />} />isme shradha ka code h polotnodesignnew wali me dpk ka */}
          <Route path="/Design" element={<PolotnoDesignNew store={store} />} />
          <Route path="/Design/:id" element={<PolotnoDesignNew store={store} />} />
          <Route
            path="/newdesign"
            element={<PolotnoDesignNew store={store} />}
          />
          <Route path="/variation" element={<Variation />} store={store} />
          <Route path="/variation/:id" element={<Variation />} store={store} />
          <Route path="/sizes" element={<SizesShirt />} />
          {/* below routes commented by vashisth to keep only export one screen that is cloud rendering */}
          {/* <Route
            path="/export/:id"
            element={<Export store={exportStore} designStore={store} />}
          />
          <Route
            path="/export-v2/:id"
            element={<ExportV2 store={exportStore} designStore={store} />}
          /> */}
          <Route
            path="/export/:id"
            element={<ExportOptimised store={exportStore} designStore={store} />}
          />
         {/*  <Route
            path="/export-optimised/:id"
            element={<ExportOptimised store={exportStore} designStore={store} />}
          /> */}
          <Route
            path="/edittshirt/:id/:designId"
            element={<EditTshirt store={exportStore} />}
          />
          <Route path="/mydesigns" element={<MyDesigns store={store} />} />
        </Routes>
      </Suspense>
    </>
  );
}
